export { default } from './isNumber'
